var ACCESSIBLE_COLOR_SCHEMA = {
    "brand": "#FFA268", // Bold yellow (keeps identity but WCAG compliant)
    "light": "#FFFFFF", // Stays white for contrast
    "error": "#FF0033", // More vivid red
    "success": "#00C853", // Bright green, passes contrast
    "text": "#ffffff", // Black text
    "textLight": "#EDEDED", // Very light gray
    "textDark": "#CCCCCC", // Light gray, more contrast
    "textOnBrand": "#000000", // Ensures legibility on yellow
    "textBrandOnWhite": "#000000", // Text over white stays black
    "gray90": "#1A1A1A", // Darker gray for sharper contrast
    "border": "#444444", // Medium-dark border
    "borderBackgroundRegular": "#fff", // Darker for higher contrast
    "borderBackgroundLight": "#fff", // Black-adjacent
    "borderBackgroundDark": "#fff", // Light gray for border separation
    "backgroundDark": "#000000", // Absolute black
    "backgroundGray": "#0e0e0e", // Darker background
    "backgroundLight": "#1e1e1e", // White for highest contrast
    "menuElement": "#FFFFFF", // White text/icons
    "menuElementLight": "#000000", // Inverted for visibility
    "shadowDark": "rgba(255, 255, 255, 0.7)", // Light shadow on dark
    "shadowSoft": "rgba(255, 255, 255, 0.2)", // Subtle white shadow
    "surface": "#1A1A1A", // Dark gray surface
    "surface_light": "#000000", // Inverse from light to black
    "surface_dark": "#2E2E2E", // Still dark, but slightly lifted
    "carbon": "#FFFFFF", // Invert for high contrast
    "carbon_dark": "#FFFFFF", // Same, brighter
    "carbon_light": "#FFFFFF", // Dark text on light
    "carbon_alphaHigh": "#444444", // Transparent white variant
    "carbon_alphaMedium": "#2f2f2f", // Lightened variant
    "accent": "#FFA268", // Vivid orange
    "accent2": "#FFA268", // Pure green for max contrast
    "muiForceBorder": true // Forced borders for clarity
};
export default ACCESSIBLE_COLOR_SCHEMA;
